const Chip = ({ text }: { text: string }) => {
  return (
    <div className="flex items-center justify-center py-1 px-3   rounded-full leading-normal text-gray-500 bg-ring-color dark:text-gray-300 dark:bg-gray-700 ng-star-inserted">
      {text}
    </div>
  );
};

export default Chip;
